export default function Subscribe(){
    return(
        <section id="contact" className="pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                className="subscribe-wrapper bg_img"
                data-background="assets/images/bg/bg-5.jpg"
              >
                <div className="row align-items-center">
                  <div style={{textAlign:'center'}} className="col-lg-12">
                    <h2 className="title">So what are you guys waiting for ?</h2>
                  </div>
                  {/* <div className="col-lg-7 mt-lg-0 mt-4">
                    <form className="subscribe-form">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                      />
                      <button className="subscribe-btn">
                        <i className="las la-envelope" />
                      </button>
                    </form>
                  </div> */}
                </div>
              </div>
              {/* subscribe-wrapper end */}
            </div>
          </div>
        </div>
      </section>     
    );
}